module.exports = __webpack_public_path__ + "static/alab-logo-60753b921c431382cfa545acce0ee4f2.png";